import { render } from "./StoreInformation.vue?vue&type=template&id=616d85de&scoped=true"
import script from "./StoreInformation.vue?vue&type=script&lang=js"
export * from "./StoreInformation.vue?vue&type=script&lang=js"

import "./StoreInformation.vue?vue&type=style&index=0&id=616d85de&scoped=true&lang=css"

import exportComponent from "/Users/admin/Desktop/bos-vue/node_modules/_vue-loader@17.0.0@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-616d85de"]])

export default __exports__